

import '../pages/Gachapon.scss';
import { useLottie } from "lottie-react";
import { useEffect, useState } from "react";

import gachaponFragment from "./gachapon_fragments.json";


const GachaponSpin = ({endAnimation}: {endAnimation:() => void}) => {
    
    const options = {
      animationData: gachaponFragment,
      loop: false,
      autoplay: false,
      onComplete: () => {
        endAnimation()
      }
    };
  
    const { View, play } = useLottie(options);

    useEffect(() => {

            play()
        
    }, [play])

    return (<div className="Gachapon--Fragments-Animation">
        {View}
    </div>);
  };


  const GachaponFragments = ({closeFragments, showAnimation}: {closeFragments:() => void, showAnimation:boolean}) => {
    


      return (
        <div className={`Gachapon--Fragments ${showAnimation ? "show" : ""} `}>
            <div className={`Gachapon--Fragments--Content`}>
               {showAnimation && <GachaponSpin endAnimation={() => { closeFragments()  }}/>}
                
            </div>
            
        </div>
      )

  }

  export default GachaponFragments;